import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  ButtonGroup,
  Dropdown,
  // DropdownMenu,
  // DropdownItem,
  DropdownToggle,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
} from "reactstrap";
import { connect } from "react-redux";
import { AvForm } from "availity-reactstrap-validation";
import moment from "moment";
import swal from "sweetalert";
import { Link } from "react-router-dom";

import SimpleBar from "simplebar-react";
import {
  getIGPList,
  SetParams,
  toggleItemMenu,
  listlayout,
} from "../../store/ingatepass/actions";
import Defaultuser from "../../assets/images/users/Default_User.png";
import LoadingModel from "../LoadingModel";

class AllInGatePass extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleDelete = this.handleDelete.bind(this);
  }
  onSortChange = () => {
    var sort = ["code", "createdon"];
    var currentSort = this.props.params.currentSort;
    var i = sort.indexOf(currentSort);
    if (i !== -1 && i + 1 < sort.length) {
      currentSort = sort[i + 1];
    } else {
      currentSort = sort[0];
    }
    this.props.SetParams({ ...this.props.params, currentSort: currentSort });
    this.props.getIGPList({
      ...this.props.params,
      currentSort: currentSort,
    });
  };
  onSortOrderChange = () => {
    // var sort = ["", "-"];
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getIGPList({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  onlayoutChange = () => {
    var layout = this.props.layout;
    if (layout === "list") {
      layout = "table";
    } else {
      layout = "list";
    }
    this.props.listlayout(layout);
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getIGPList(
        {
          ...this.props.params,
          search: "",
          page: 1,
        },
        true
      );
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getIGPList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getIGPList({ ...this.props.params, page: pageNo });
  }
  handleDelete = (Qid) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        // this.handleDelete(Qid);
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  render() {
    return (
      <React.Fragment>
         {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

        <div className="mt-2 ">
          <div>
            <Row>
              <Col md={3}>
                <AvForm className="p-1">
                  <FormGroup className="m-0">
                    <InputGroup>
                      <Input
                        type="text"
                        name="search"
                        className="form-control d-inline-block"
                        placeholder="Search"
                        validate={{ required: true }}
                        onChange={(e) => this.autohandleSearch(e)}
                        onKeyDown={(e) => this.handleSearch(e)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="light"
                          type="submit"
                          onClick={() =>
                            this.props.getIGPList({
                              ...this.props.params,
                              page: 1,
                            })
                          }
                        >
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </AvForm>
              </Col>
              <Col md={9}>
                <div className="float-right p-1">
                  <div className="d-inline-block">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          previous
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          next
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                  <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                    <Button color="light" onClick={this.onSortOrderChange}>
                      {this.props.params.sortOrder === "" && (
                        <i className="mdi mdi-sort-ascending mr-1"></i>
                      )}
                      {this.props.params.sortOrder === "-" && (
                        <i className="mdi mdi-sort-descending mr-1"></i>
                      )}
                    </Button>
                    <Button color="light" onClick={this.onSortChange}>
                      {this.props.Sortvar[this.props.params.currentSort]}
                    </Button>
                  </ButtonGroup>
                  <Button color="light" onClick={this.onlayoutChange}>
                    {this.props.layout === "list" && (
                      <i className="mdi mdi-table-large"></i>
                    )}
                    {this.props.layout === "table" && (
                      <i className="mdi mdi-format-list-bulleted"></i>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <SimpleBar style={{ maxHeight: "100%" }}>
            <Card className="p-0">
              <CardBody className="p-2">
                {this.props.layout === "table" && (
                  <CardBody className="p-2 ">
                    <div className="table-responsive m-0">
                      <Table bordered hover className="mb-0 p-0 table-centered">
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="nowrap">Quotation Code</th>
                            <th className="nowrap">No.of Items</th>
                            <th className="nowrap">No.of PO</th>
                            <th className="nowrap">IGP Date</th>
                            <th className="nowrap">Vehicle No</th>
                            <th className="nowrap">Person Name</th>
                            <th className="nowrap">Remarks</th>
                            {/* <th className="nowrap">RFQ No:</th> */}

                            {/* <th className="nowrap">Action</th> */}
                          </tr>
                        </thead>
                        <tbody className="nowrap">
                          {this.props.IGPRowListCount !== 0 ? (
                            <>
                              {this.props.IGPRowList?.map((igp, key) => (
                                <tr key={key} className="text-center">
                                  <td>
                                    <Link to={`ingatepass/${igp.id}`}>
                                      <Button
                                        type="button"
                                        color="success"
                                        className="waves-effect waves-light orderlist_but m-2 p-1 mb-2"
                                      >
                                        <i className="mdi mdi-file-document mr-1"></i>
                                        {igp.code}
                                      </Button>
                                    </Link>
                                  </td>
                                  <td>
                                    {igp.items_count} Items
                                    {/* <Link
                                      to="#"
                                      className="m-0"
                                      // onClick={() =>
                                      //   this.props.rf_model_list_open(item.id)
                                      // }
                                    >
                                      {igp.items_count} Items
                                    </Link> */}
                                  </td>
                                  <td>{igp.poitems_count} PO</td>

                                  <td>
                                    {moment(igp.createdon).format("DD-MM-YYYY")}
                                  </td>
                                  <td>{igp.vehicleno}</td>
                                  <td>{igp.personname}</td>
                                  <td>{igp.description}</td>

                                  {/* <td>
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="primary"
                                      className="waves-effect waves-light mr-2"
                                      // disabled={
                                      //   PIItem.pistatus === 1 ? false : true
                                      // }
                                      href={`Newigp/${igp.id}`}
                                    >
                                      <i className="mdi mdi-backup-restore icon-large "></i>
                                    </Button>
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="danger"
                                      className="waves-effect waves-light"
                                      onClick={() => this.handleDelete(igp.id)}
                                    >
                                      <i className="mdi mdi-delete icon-large "></i>
                                    </Button>
                                  </td> */}
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="7" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                )}
                {this.props.layout === "list" && (
                  <>
                    {this.props.IGPRowListCount !== 0 ? (
                      <>
                        {this.props.IGPRowList.map((igp) => (
                          <div className="bg_color p-0 mb-1" key={igp.id}>
                            <Row className="justify-content-center">
                              <Col md={2} className="pb-0 mb-0">
                                <div className="igp_detiles p-2">
                                  <Link to={`ingatepass/${igp.id}`}>
                                    <Button
                                      type="button"
                                      color="success"
                                      className="waves-effect waves-light orderlist_but m-2 p-1 mb-2"
                                    >
                                      <i className="mdi mdi-file-document mr-1"></i>
                                      {igp.code}
                                    </Button>
                                  </Link>
                                  <p className="items_title m-2">
                                    List PO:{" "}
                                    <span className="item_title_Detiles">
                                      {igp.poitems_count}
                                    </span>
                                  </p>

                                  <p className="items_title m-2">
                                    List Items:{" "}
                                    <span className="item_title_Detiles">
                                      {igp.items_count}
                                    </span>
                                  </p>
                                </div>
                              </Col>
                              <Col md={10} className="pb-0 mb-0">
                                <div className="igp_body">
                                  <div className="float-right ml-3">
                                    <ButtonGroup>
                                      <Dropdown
                                        isOpen={igp.actionMenu}
                                        toggle={() =>
                                          this.props.toggleItemMenu(igp.id)
                                        }
                                      >
                                        <DropdownToggle
                                          caret
                                          color="light"
                                          size="sm"
                                        >
                                          <i className="ri-more-line "></i>
                                        </DropdownToggle>
                                        {/* <DropdownMenu right>
                                          <DropdownItem
                                            href={`NewQuotation/${igp.id}`}
                                          >
                                            Edit Request
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={() =>
                                              this.handleDelete(igp.id)
                                            }
                                          >
                                            Delete Request
                                          </DropdownItem>
                                        </DropdownMenu> */}
                                      </Dropdown>{" "}
                                    </ButtonGroup>
                                  </div>
                                </div>
                                {/* <hr className="my-0" /> */}
                                <Row className="p-0 mb-0">
                                  <Col md={8} className="p-0 pb-0 mb-0">
                                    <div className="Quotation-panel-content">
                                      <div className="list-column">
                                        <ul className="list-style-seven p-0">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              IGP Date:
                                            </span>
                                            <span className="dtl">
                                              {moment(igp.createdon).format(
                                                "DD-MM-YYYY"
                                              )}
                                            </span>
                                          </li>

                                          <li className="clearfix">
                                            <span className="ttl">
                                              Vehicle No:
                                            </span>
                                            <span className="dtl">
                                              {igp.vehicleno}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Person Name:
                                            </span>
                                            <span className="dtl">
                                              {igp.personname}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Remarks:
                                            </span>
                                            <span className="dtl">
                                              {igp.description}
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="float-right pt-4">
                                      <ul className="user-column p-0">
                                        <li className="clearfix p-0 m-0">
                                          <span className="img">
                                            <img
                                              className="img-fluid p-0"
                                              src={
                                                igp.createdby.image == null
                                                  ? Defaultuser
                                                  : igp.createdby.image
                                              }
                                              alt="user"
                                            />
                                          </span>
                                          <span className="ttl ">
                                            {igp.createdby.fullname}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center">
                        <span className="font-size-24 text-danger">
                          Data not available{" "}
                        </span>
                      </div>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </SimpleBar>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    IGPRowList,
    IGPRowListCount,
    params,
    Sortvar,
    QlistModel,
    layout,
    loading,
  } = state.ingatepass;
  return {
    IGPRowList,
    IGPRowListCount,
    params,
    Sortvar,
    QlistModel,
    layout,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getIGPList,
  SetParams,
  toggleItemMenu,
  listlayout,
})(AllInGatePass);
